module.exports = __webpack_public_path__ + "static/media/icon_projects.12828143.svg";